import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch.jsx';

const viewerFragment = graphql`
    fragment SbSharedRefineMenuFilterOrigin_viewer on Viewer {
        ...SbSharedRefineMenuMultiSelectSearch_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterOrigin_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectSearch_itemSearch
    }
`;

export const SbSharedRefineMenuFilterOrigin = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    collapsedItemCount,
    filterName,
    values,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectSearch
            viewer={viewer}
            itemSearch={itemSearch}
            filterName={filterName}
            collapsedItemCount={collapsedItemCount}
            values={values}
        />
    );
};

SbSharedRefineMenuFilterOrigin.propTypes = {
    viewer: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    collapsedItemCount: PropTypes.number,
    values: PropTypes.array.isRequired,
};
